/*
 * Developed for G.J. Gardner Homes by Softeq Development Corporation
 * http://www.softeq.com
 */

import { entity } from '@gh/core-data';
import { FormulaMapper } from '../common/formula.mapper';
import { ComponentItemFinderListItemDto } from './component-item-finder-list-item.dto';

export const ComponentItemFinderListItemMapper = entity<ComponentItemFinderListItemDto>({
  formula: FormulaMapper,
});
